<template>
  <busy-area :busy="loadingHistoryDifference">
    <h2>{{ fullTitle }}</h2>
    <div class="flex flex-wrap gap-x-10 gap-y-10 pb-10 pt-5">
      <div class="flex flex-col justify-stretch">
        <table class="statisticsTable h-full">
          <thead>
            <tr>
              <th>{{ $t('pages.history.property') }}</th>
              <th>{{ $t('pages.history.value') }}</th>
              <th>{{ $t('pages.history.property') }}</th>
              <th>{{ $t('pages.history.value') }}</th>
              <th>{{ $t('pages.history.property') }}</th>
              <th>{{ $t('pages.history.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('pages.history.distinctUsers') }}</td>
              <td>{{ historyDifferenceItem?.distinctUsers ?? '-' }}</td>
              <td>{{ $t('pages.history.uniqueUsersLastDay') }}</td>
              <td>{{ historyDifferenceItem?.uniqueUsersLastDay ?? '-' }}</td>
              <td>{{ $t('pages.history.uniqueUsersLast7Days') }}</td>
              <td>{{ historyDifferenceItem?.uniqueUsersLast7Days ?? '-' }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.history.uniqueUsersLast30Days') }}</td>
              <td>{{ historyDifferenceItem?.uniqueUsersLast30Days ?? '-' }}</td>
              <td>{{ $t('pages.history.totalRequests') }}</td>
              <td>{{ historyDifferenceItem?.totalRequests ?? '-' }}</td>
              <td />
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </busy-area>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { format } from 'date-fns';
import { useI18n } from 'vue-i18n';
import BusyArea from '@utils/busy/BusyArea.vue';
import { useProvider } from '@utils/table/hooks/provider';

interface HistoryUsageDifferenceDto {
  startDate?: Date;
  endDate?: Date;
  source: string;
  distinctUsers: number;
  uniqueUsersLastDay: number;
  uniqueUsersLast7Days: number;
  uniqueUsersLast30Days: number;
  totalRequests: number;
}

interface Props {
  providerParams: object;
}

const { t } = useI18n();
const props = defineProps<Props>();

const {
  data: historyDifferenceItem,
  loading: loadingHistoryDifference,
} = useProvider<HistoryUsageDifferenceDto>('/history_usage_statistics/difference', props.providerParams);

function formatDate(date: Date | undefined) {
  return date && format(new Date(date), 'dd.MM.yyyy - HH:mm:ss');
}

const fullTitle = computed(() => {
  const startDate = formatDate(historyDifferenceItem.value?.startDate);
  const endDate = formatDate(historyDifferenceItem.value?.endDate);
  return `${t('pages.history.difference.title.differenceFrom')} ${startDate} ${t('pages.history.difference.title.to')} ${endDate}`;
});
</script>

<style lang="scss" scoped>
.statisticsTable {
  @apply border;

  tr {
    td, th {
      &:not(:last-child) {
        @apply border-r;
      }

      @apply px-5 py-2;
      text-align: right;
    }

    th {
      @apply border-b;
    }
  }
}
</style>
